import React from "react";
import { Modal, Button, Text, Group } from "@mantine/core";

interface UploadErrorModalProps {
  opened: boolean;
  errorMessage: string;
  maxSizeInMb: number;
  onClose: () => void;
  onRetry: () => void;
}

const UploadErrorModal: React.FC<UploadErrorModalProps> = ({
  opened,
  errorMessage,
  maxSizeInMb,
  onClose,
  onRetry,
}) => (
  <Modal
    opened={opened}
    onClose={onClose}
    title="File upload failed"
    centered
    size="lg"
  >
    <Text size="sm" weight={600} mb="sm">
      {errorMessage}
    </Text>

    <Text size="sm" mb="md">
      Please double-check that your file is saved in the right format (Files
      must be .CSV, .XLSX or .PDF. Max file size is {maxSizeInMb}MB) before
      trying again. If you require further assistance please reach out to{" "}
      <Text component="span" className="text-jem-link">
        customersuccess@jemhr.com
      </Text>
      .
    </Text>

    <Group position="right" spacing="sm">
      <Button variant="outline" onClick={onClose}>
        Close
      </Button>
      <Button onClick={onRetry}>Re Upload</Button>
    </Group>
  </Modal>
);

export default UploadErrorModal;
